export default __webpack_public_path__ + "static/recog-biopharma-awards-0a57f2ed663b04e41bfe4f9332f2d7a7.gif";